/** Verwendung zum Serializieren und deserializieren von Objkten */

/** Request dient für die Erstellung einer HTTP Anfrage */
export class Serializer {

  /** hilfsmethode um auch Errors als Json ausgeben zu können */
  private static replaceErrors(key, value) {
    if (value instanceof Error) {
      var error = {};
      Object.getOwnPropertyNames(value).forEach((sub_key) => {
        error[sub_key] = value[sub_key];
      });
      return error;
    }
    return value;
  }

  /** serialize object or array to string
   * @param obj Object or array for serialization
   * @returns Serialized object or array
   */
  public static serialize(obj: {} | {}[]): string {
    return JSON.stringify(obj, Serializer.replaceErrors);
  }

  /** deserialize object or array from string
   * @param data Serialized object or array
   * @returns Deserialized object or array
   */
  public static deserialize(data: string): {} | {}[] {
    return JSON.parse(data);
  }

  /** privater constructor da die classe static ist */
  private constructor() {
  }
}
